import { SolNavbar, SolNavbarItem } from '@sol/components';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { SolIcon } from '@sol/icons';

export const navbarAdmin: SolNavbar = {
  menu: [
    SolNavbarItem.of(AsmRouteId.admin_dashboard, {
      displayName: 'asm-route.admin.dashboard',
      icon: SolIcon.asm_dashboard,
    }),
    SolNavbarItem.of(AsmRouteId.admin_partners, {
      displayName: 'asm-route.admin.partners',
      icon: SolIcon.users,
    }),
    SolNavbarItem.of(AsmRouteId.admin_access_management, {
      displayName: 'asm-route.partner.access-management',
      icon: SolIcon.asm_access_control,
      children: [
        SolNavbarItem.of(AsmRouteId.admin_users, {
          displayName: 'asm-route.partner.users',
          icon: SolIcon.users,
        }),
        SolNavbarItem.of(AsmRouteId.admin_roles, {
          displayName: 'asm-route.partner.roles',
          icon: SolIcon.bookmark,
        }),
        SolNavbarItem.of(AsmRouteId.admin_api, {
          displayName: 'asm-route.partner.api',
          icon: SolIcon.asm_api,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.admin_api_tokens, {
              displayName: 'asm-route.partner.api-tokens',
            }),
            SolNavbarItem.of(AsmRouteId.admin_api_docs, {
              displayName: 'asm-route.partner.api-docs',
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.admin_derived_access, {
          displayName: 'asm-route.admin.derived-access',
          icon: SolIcon.bookmark,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.admin_derived_roles, {
              displayName: 'asm-route.admin.derived-roles',
            }),
            SolNavbarItem.of(AsmRouteId.admin_access_reasons, {
              displayName: 'asm-route.admin.access-reasons',
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.admin_usage, {
      displayName: 'asm-route.admin.usage',
      children: [
        SolNavbarItem.of(AsmRouteId.admin_billing, {
          displayName: 'asm-route.usage-overview',
          icon: SolIcon.usage,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.admin_billing_overview, {
              displayName: 'asm-route.usage.overview',
            }),
            SolNavbarItem.of(AsmRouteId.admin_billing_events, {
              displayName: 'asm-route.usage.events',
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.internal, {
      displayName: 'asm-route.internal',
      children: [
        SolNavbarItem.of(AsmRouteId.internal_tasks, {
          displayName: 'asm-route.internal-tasks',
          icon: SolIcon.check_square,
        }),
        SolNavbarItem.of(AsmRouteId.internal_drp_sources, {
          displayName: 'asm-route.internal.drp-sources',
          icon: SolIcon.asm_drp,
          children: [
            SolNavbarItem.of(AsmRouteId.internal_drp_sources_modules, {
              displayName: 'asm-route.drp-source-modules',
              icon: SolIcon.agent,
              showChildrenInNavbar: false,
              children: [
                SolNavbarItem.of(AsmRouteId.internal_drp_sources_modules_module, {
                  displayName: 'asm-route.drp-source-module',
                  nameParams: ['moduleName'],
                  showChildrenAsTabs: true,
                  children: [
                    SolNavbarItem.of(AsmRouteId.internal_drp_sources_modules_module_overview, {
                      displayName: 'asm-route.drp-source-modules-overview',
                    }),
                  ],
                }),
              ],
            }),
            SolNavbarItem.of(AsmRouteId.internal_drp_sources_sources, {
              displayName: 'asm-route.drp-source-sources',
              icon: SolIcon.network_discovery,
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.admin_smoke_tests, {
      displayName: 'asm-smoke-tests.nav.smoke-tests',
      icon: SolIcon.check,
      showChildrenAsTabs: true,
      children: [
        SolNavbarItem.of(AsmRouteId.admin_smoke_tests_suites, {
          displayName: 'asm-smoke-tests.nav.test-suites',
        }),
        SolNavbarItem.of(AsmRouteId.admin_smoke_tests_runs, {
          displayName: 'asm-smoke-tests.nav.runs',
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.admin_smoke_tests_run, {
              displayName: 'asm-smoke-tests.nav.run-detail',
              nameParams: ['runId'],
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.resources, {
      displayName: 'asm-route.resources',
      children: [
        SolNavbarItem.of(AsmRouteId.banners, {
          displayName: 'asm-route.banners',
          icon: SolIcon.notification,
        }),
        SolNavbarItem.of(AsmRouteId.dashboards, {
          displayName: 'asm-route.dashboards',
          icon: SolIcon.asm_dashboard,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.dashboards_overview, {
              displayName: 'asm-route.dashboards-overview',
              showChildrenInNavbar: false,
              children: [
                SolNavbarItem.of(AsmRouteId.dashboards_detail, {
                  displayName: 'asm-route.dashboard-detail',
                  nameParams: ['dashboardName'],
                }),
              ],
            }),
            SolNavbarItem.of(AsmRouteId.dashboards_definitions, {
              displayName: 'asm-route.dashboards-definitions',
            }),
            SolNavbarItem.of(AsmRouteId.dataSources, {
              displayName: 'asm-route.data-sources',
            }),
            SolNavbarItem.of(AsmRouteId.widgets, {
              displayName: 'asm-route.widgets',
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.admin_platform_settings, {
          displayName: 'asm-route.admin.platform-settings',
          icon: SolIcon.settings,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.admin_settings_rules, {
              displayName: 'asm-route.admin.settings-rules',
            }),
            SolNavbarItem.of(AsmRouteId.admin_settings_definitions, {
              displayName: 'asm-route.admin.settings-definitions',
            }),
          ],
        }),
      ],
    }),
  ],
  system: [
    SolNavbarItem.of(AsmRouteId.debug, {
      displayName: 'asm-route.debug',
      icon: SolIcon.vulnerability,
    }),
  ],
  account: [
    SolNavbarItem.of(AsmRouteId.account_section1, {
      children: [
        SolNavbarItem.of(AsmRouteId.account_documentation, {
          displayName: 'asm-route.documentation',
        }),
        SolNavbarItem.of(AsmRouteId.account_profile, {
          displayName: 'asm-route.profile',
        }),
        SolNavbarItem.of(AsmRouteId.account_preferences, {
          displayName: 'asm-route.preferences',
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.account_section2, {
      children: [
        SolNavbarItem.of(AsmRouteId.account_logout, {
          displayName: 'asm-route.logout',
        }),
      ],
    }),
  ],
};
